require('innersvg-polyfill');
import smoothscroll from 'smoothscroll-polyfill';
 
smoothscroll.polyfill();

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

(function() {
    if (typeof window.Event === 'function') return false; //If not IE

    function Event(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(
            event,
            params.bubbles,
            params.cancelable,
            params.detail
        );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.Event = CustomEvent;
})();



// WEBPACK FOOTER //
// ./resources/assets/js/setup/polyfills.js